import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// コンポーネントのインポート
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Collabo } from "./components/collabo";
import { Team } from "./components/Team";
import { News } from "./components/news";
import FAQ from './components/faq';
import { Contact } from "./components/contact";

// ページコンポーネントのインポート
import ContactPage from './pages/ContactPage';
import AgriculturePlatformPage from './pages/AgriculturePlatformPage';
import AwardsPage from './pages/AwardsPage';
import PartnershipPage from './pages/PartnershipPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import MissionVisionPage from './pages/MissionVisionPage';
import TechnologyPage from './pages/TechnologyPage';
import TechnologyPatentsPage from './pages/TechnologyPatentsPage';
import TechnologyDemoPage from './pages/TechnologyDemoPage';
import GlossaryPage from './pages/GlossaryPage';
import FAQPage from './pages/FAQPage';
import TechnologyCorePage from './pages/TechnologyCorePage';
import NewsIRPage from './pages/NewsIRPage';
import CareersPage from './pages/CareersPage';
import CompanyInfoPage from './pages/CompanyInfoPage';
import SolutionsPage from './pages/SolutionsPage';
import ResourceCenterPage from './pages/ResourceCenterPage';

import JsonData from "./data/data.json";

function App() {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
    document.documentElement.classList.add('dark');
  }, []);

  // 従来のランディングページレイアウト
  const LandingPageLayout = () => (
    <div className="dark">
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Collabo data={landingPageData.Collabo} />
      <Team data={landingPageData.Team} />
      <News />
      <FAQ />
      <Contact data={landingPageData.Contact} />
    </div>
  );

  return (
    <Router>
      <div className="dark">
        <Routes>
          {/* ホームページ（従来のランディングページ） */}
          <Route path="/" element={<LandingPageLayout />} />
          
          {/* 技術・ソリューション */}
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/technology/core" element={<TechnologyCorePage />} />
          <Route path="/technology/patents" element={<TechnologyPatentsPage />} />
          <Route path="/technology/demo" element={<TechnologyDemoPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/solutions/:category" element={<SolutionsPage />} />
          <Route path="/solutions/:category/:id" element={<SolutionsPage />} />
          
          {/* 導入事例 */}
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:id" element={<CaseStudiesPage />} />
          
          {/* 企業情報 */}
          <Route path="/company" element={<CompanyInfoPage />} />
          <Route path="/company/overview" element={<CompanyInfoPage />} />
          <Route path="/company/management" element={<CompanyInfoPage />} />
          <Route path="/company/rd" element={<CompanyInfoPage />} />
          <Route path="/company/mission" element={<MissionVisionPage />} />
          <Route path="/company/awards" element={<AwardsPage />} />
          
          {/* 農業プラットフォーム */}
          <Route path="/agriculture" element={<AgriculturePlatformPage />} />
          
          {/* リソースセンター */}
          <Route path="/resources" element={<ResourceCenterPage />} />
          <Route path="/resources/whitepapers" element={<ResourceCenterPage />} />
          <Route path="/resources/technical-docs" element={<ResourceCenterPage />} />
          <Route path="/resources/webinars" element={<ResourceCenterPage />} />
          
          {/* ニュース・IR */}
          <Route path="/news" element={<NewsIRPage />} />
          <Route path="/news/:id" element={<NewsIRPage />} />
          
          {/* 採用情報 */}
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/:id" element={<CareersPage />} />
          
          {/* お問い合わせ */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/contact/general" element={<ContactPage />} />
          <Route path="/contact/demo" element={<ContactPage />} />
          <Route path="/contact/materials" element={<ContactPage />} />
          
          {/* サポート・パートナーシップ */}
          <Route path="/resources/faq" element={<FAQPage />} />
          <Route path="/resources/glossary" element={<GlossaryPage />} />
          <Route path="/contact/partnership" element={<PartnershipPage />} />
        </Routes>
        
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </Router>
  );
}

export default App;